import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './ghs-pager.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * Pager Component
 * @element ghs-pager
 */
@customElement('ghs-pager')
export class GhsPager extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  render(): TemplateResult {
    return html`
      <nav class="pager" role="navigation">
        <slot></slot>
      </nav>
    `;
  }
}
